import { Injectable, OnDestroy } from "@angular/core";
import { ChangeStatusEnum } from "@docma-mm-core/model/change-state/change-status.enum";
import { LoadState } from "@docma-mm-core/model/load-state/load-state";
import { LoadStatusEnum } from "@docma-mm-core/model/load-state/load-state.enum";
import { Attachment, AttachmentData, AttachmentSource } from "./attachment";

@Injectable()
export class AttachmentDataLoaderService implements OnDestroy {

  ngOnDestroy(): void {
  }


  //
  public mergeWithLoadData(attachments: Attachment[], loadData: Array<AttachmentData>, loadDate?: Date): Attachment[] {
    loadDate = loadDate ?? new Date(Date.now());
    const oldAttachments = attachments || [];
    const loadAttachmnetsData = loadData ? [...loadData] : [];

    const mergedAttachments: Array<Attachment> = [];

    oldAttachments.forEach(oa => {

      const found = loadAttachmnetsData.find(a => a.UniqueId === oa.uid);
      if (found) {
        oa.loadState = new LoadState({ data: found, date: loadDate, status: LoadStatusEnum.Loaded });
        mergedAttachments.push(oa);
      } else if (oa.isNew) {
        mergedAttachments.push(oa);
      }
    });

    loadAttachmnetsData.forEach(ad=> {
      if (!mergedAttachments.find(ma=> ma.id === ad.Id)) {
        mergedAttachments.push(new Attachment({loadState: new LoadState({ data: ad, date: loadDate, status: LoadStatusEnum.Loaded })}));
      }
    })

    return mergedAttachments.sort((a, b) => {
      const d1 = a.data.Date != null ? new Date(a.data.Date).getTime() : 0;
      const d2 = b.data.Date != null ? new Date(b.data.Date).getTime() : 0;
      return d2 - d1;
    });

  }

}
